import Handlebars from 'handlebars/dist/handlebars';

const reverseUrl = function(urlName, kargs = {}) {
  let url = window.routes[urlName];
  if (!url) {
    throw new Error(`URL '${urlName}' was not found.`);
  }

  Object.keys(kargs).forEach((key) => {
    const value = kargs[key]
    if (typeof value === 'undefined' || value === '') {
      throw new Error(`Invalid URL lookup: URL '${url}'. Argument '${key}' was not provided.`)
    }

    url = url.replace(new RegExp(`<${key}>`), value)
  })

  return url;
}

Handlebars.registerHelper('json', (context) => new Handlebars.SafeString(JSON.stringify(context)))

Handlebars.registerHelper('url', (routerName, { hash }) => {
  const urlString = reverseUrl(routerName, hash)
  return new Handlebars.SafeString(urlString)
})

Handlebars.registerHelper('ifCond', function (v1, operator, v2, options) {
  switch (operator) {
    case '==':
      return (v1 == v2) ? options.fn(this) : options.inverse(this)
    case '===':
      return (v1 === v2) ? options.fn(this) : options.inverse(this)
    case '!=':
      return (v1 != v2) ? options.fn(this) : options.inverse(this)
    case '!==':
      return (v1 !== v2) ? options.fn(this) : options.inverse(this)
    case '<':
      return (v1 < v2) ? options.fn(this) : options.inverse(this)
    case '<=':
      return (v1 <= v2) ? options.fn(this) : options.inverse(this)
    case '>':
      return (v1 > v2) ? options.fn(this) : options.inverse(this)
    case '>=':
      return (v1 >= v2) ? options.fn(this) : options.inverse(this)
    case '&&':
    case 'and':
      return (v1 && v2) ? options.fn(this) : options.inverse(this)
    case '||':
    case 'or':
      return (v1 || v2) ? options.fn(this) : options.inverse(this)
    default:
      return options.inverse(this)
  }
})

// Register partial templates
const selector = [...window.document.querySelectorAll('[type="text/x-handlebars-partial"]')]
selector.forEach((element) => {
  Handlebars.registerPartial(element.id, element.innerHTML)
})

// Re-use methods
export const handlerbarsRender = (html, params = {}, wrap = false) => {
  const template = Handlebars.compile(html)
  const globalParams = {}
  const templateHtml = template({
    ...globalParams,
    ...params,
  })
  return templateHtml
}

export const handlerbarsRenderByName = (templateName, params = {}, wrap = false) => {
  // templateName Contain dot in name
  document.getElementById(templateName)
  const templateScriptElement = document.getElementById(templateName)
  if (!templateScriptElement) {
    throw new Error(`Template name ${templateName} does not exist`)
  }

  return handlerbarsRender(templateScriptElement.innerHTML, params, wrap)
}

Handlebars.registerHelper('if_sale', function(sale, option) {
  if (sale > 0) {
    return option.fn(this);
  }
  return option.inverse(this);
});

Handlebars.registerHelper('truncate', (str, len) => {
  if (str) {
    if (str.length > len && str.length > 0) {
      var new_str = `${str} `;
      new_str = str.substr(0, len);
      new_str = str.substr(0, new_str.lastIndexOf(' '));
      new_str = (new_str.length > 0) ? new_str : str.substr(0, len);

      return new Handlebars.SafeString(`${new_str}...`);
    }
  }
  return str;
})

Handlebars.registerHelper('price_format', (str) => parseFloat(str).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))
